<template lang="pug">
    v-content
        v-toolbar(flat="" color="white")
            v-toolbar-title סנדי - הגדרות כפתורים
            v-divider.mx-2(inset="" vertical="")
            v-spacer
            v-dialog(v-model="dialog" max-width="800px").rtl
                v-btn.mb-2(slot="activator" color="primary" dark="") כפתור חדש
                v-card
                    v-card-title
                        span.headline {{ formTitle }}
                    v-card-text
                        v-container(grid-list-md="").rtl
                            v-layout(wrap="")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.screen_id" label="מספר מסך")
                                v-flex(xs12)
                                    v-select(reverse v-model="editedItem.button_type" :items="['input', 'click']", item-text="he_value" item-value="value" label='סוג כפתור')
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.column_name" label="עמודה")
                                v-flex(xs12)
                                  v-text-field(reverse right v-model="editedItem.button_placeholder" label="text / placeholder")
                                v-flex(xs12)
                                  v-text-field(reverse right v-model="editedItem.column_to_update" label="העמודה המתעדכנת")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.now_value" label="הערך החדש")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.column_to_update_now" label="עדכון now בעמודה")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.column_to_update_user" label="עדכון user בעמודה")
                                v-flex(xs12).ltr
                                  v-switch(v-model="editedItem.show_cancel_button" label="להציג כפתור ביטול?")

                    v-card-actions
                        v-spacer
                        v-btn(color="blue darken-1" flat="" @click="close") Cancel
                        v-btn(color="blue darken-1" flat="" @click="save(editedItem)") Save
        v-data-table#setting-table.elevation-1(
                :headers="headers"
                :items="desserts"
                :loading='loading'
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
            )
            template(slot="items" slot-scope="props")
                td.text-xs-right {{ props.item.id                                   }}
                td.text-xs-right {{ props.item.screen_id                           }}
                td.text-xs-right {{ props.item.button_type                           }}
                td.text-xs-right {{ props.item.column_name                           }}
                td.text-xs-right {{ props.item.button_placeholder                           }}
                td.text-xs-right {{ props.item.column_to_update                           }}
                td.text-xs-right {{ props.item.now_value                           }}
                td.text-xs-right {{ props.item.column_to_update_now                           }}
                td.text-xs-right {{ props.item.column_to_update_user                           }}
                td.text-xs-right {{ props.item.show_cancel_button                           }}

                td.justify-center.layout.px-0
                    v-icon.ml-4(small="" @click="deleteItem(props.item)") delete
                    v-icon.ml-4(small="" @click="editItem(props.item)") edit
                    v-tooltip.v-icon.ml-4(top)
                        v-icon(slot='activator' small @click="save(props.item, true)") repeat_one
                        span שכפל
</template>

<script>
    export default {
        data: () => ({
          color55644: '',
            sort_options_system: {ASC : 'ישר', DESC : 'הפוך'},
            sort_options: [{value : 'ASC', he_value : 'ישר'}, {value : 'DESC', he_value : 'הפוך'}],
            loading: true,
            dialog: false,
            rowsPerPageItems: [10, 20, 50, 100, 1000],
            pagination: {
                rowsPerPage: 1000
            },
            headers: [
              { text: 'id'                    , value: 'id'                        , sortable: false, align : 'right' },
              { text: 'מזהה מסך'              , value: 'screen_id'                 , sortable: false, align : 'right' },
              { text: 'סוג כפתור'     , value: 'button_type'               , sortable: false, align : 'right' },
              { text: 'עמודה'     , value: 'column_name'     , sortable: false, align : 'right' },
              { text: 'טקסט כפתור'             , value: 'button_placeholder'         , sortable: false, align : 'right' },
              { text: 'עמודה מתעדכנת'     , value: 'column_to_update'           , sortable: false, align : 'right' },
              { text: 'ערך חדש'                   , value: 'now_value'                       , sortable: false, align : 'right' },
              { text: 'עמודת עדכון זמן'                   , value: 'column_to_update_now'                       , sortable: false, align : 'right' },
              { text: 'עמודת עדכון משתמש'                   , value: 'column_to_update_user'                       , sortable: false, align : 'right' },
              { text: 'הצגת כפתור ביטול?'                   , value: 'show_cancel_button'                       , sortable: false, align : 'right' },
              { text: 'פעולות'                                                     , sortable: false, align : 'right' },
            ],
            columns_style: [],
            desserts: [],
            editedItem: {},
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'כפתור חדש' : 'ערוך כפתור'
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            }
        },

        created () {
          document.title = 'ButtonBuilder';

          this.$socket.on('*', (packet) => {
                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;
                if($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            this.initialize();
            this.$emit('update:loading', false);
        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true);
            next();
        },

        methods: {
            range(first, last) {
                let a = first.charCodeAt(0)
                let b = last.charCodeAt(0) + 1
                return Array.apply(null, {length: Math.abs(b - a)})
                    .map(function (x,i) { return String.fromCharCode(Math.min(a, b) + i) });
            },


            initialize () {
                this.$socket.req('sendi.screen.buttons.all', {user: this.$user}).then(data => {
                    this.desserts = data.entities;
                        setTimeout(()=> {
                            document.getElementsByClassName('v-table__overflow')[0].scrollLeft = 20000;
                            this.loading = false;
                        });
                });
            },

            sockets : function (channel, data) {
                let channels = {
                    'sum.channel' : (/*data*/) => {
                        //console.log('sum.channel', data)
                    }
                };
                if(!channels[channel]) {
                    return console.log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            },


            editItem (item) {
                this.editedIndex = this.desserts.indexOf(item) || {};
                this.editedItem = {...item};
                this.dialog = true
            },

            deleteItem (item) {
                confirm(`בטוח? למחוק את
                    ${item.name}
                `) && this.$socket.req('sendi.screen.buttons.delete', {
                    id    : item.id
                }).then(() => {
                    this.initialize();
                });
            },


            close () {
                this.dialog = false
            },

            save (item, duplicate = false) {
                this.loading = true;

                if (duplicate) {
                    item = { ...item };
                    delete item['id'];
                }

                this.$socket.req('sendi.screen.buttons.editOrAdd', item).then(data => {
                    let itemIdx = this.desserts.findIndex(v => v.id == data.item.id);

                    if(itemIdx > -1) {
                        // this.desserts[itemIdx] = data.item;
                        this.initialize();
                    }
                    else {
                        this.desserts.push(data.item);
                    }

                    this.loading = false;
                    this.editedItem = {};
                });
                this.close()
            }
        }
    }
</script>

<style lang="sass">

    #setting-table .v-table__overflow
        /*height: 300px;*/
        overflow-y: auto
        /*direction: rtl;*/


    #setting-table .v-datatable.v-table
        direction: rtl

    #setting-table .v-datatable__actions
        direction: ltr


    .v-content__wrap
        background: #fff
    #setting-table
        table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
            padding: 0 5px

    .v-tooltip.v-icon span
        display: inline-flex


</style>